"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Models = void 0;
const bodycode_1 = require("./bodycode");
const customer_1 = require("./customer");
const offer_1 = require("./offer");
const opportunity_1 = require("./opportunity");
const resource_1 = require("./resource");
const templates_1 = require("./templates");
const transaction_1 = __importDefault(require("./transaction"));
const vehicle_1 = require("./vehicle");
exports.Models = [
    vehicle_1.VehicleModels,
    transaction_1.default,
    customer_1.CustomerModels,
    opportunity_1.OpportunityModels,
    offer_1.OfferModels,
    templates_1.TemplateModels,
    bodycode_1.BodycodeModels,
    resource_1.ResourceModels,
];
